import React, { useState } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import PropTypes from 'prop-types';

import { TextButtonSto } from 'components/sto';
import { AppRoutes } from 'routes';

import Link from '../link/Link';
import ContactModal from '../modals/ContactModal';

import SignUp from './SignUpForm';

function SignUpContent(props) {
    const [displayModal, updateModalVisibility] = useState(false);

    const onSubmit = (userDetails, maskedEmail) => {
        props.onSubmit(userDetails, maskedEmail);
    };

    return (
        <React.Fragment>
            <div className="wrapper-message pprlpay-page-primary-content">
                <div className="wrapper-button-sto-container">
                    <SignUp email={props.email} onSubmit={onSubmit} verificationkey={props.verificationkey} />

                    <p className="login-here-text">
                        <FormattedMessage id="pages.registration.links.registered.title" />
                    </p>
                    <Link id="page-registration-createUser-button-loginHere" to={AppRoutes.baseRoute}>
                        <FormattedMessage id="pages.registration.links.registered.text" />
                    </Link>

                    <div className="pprlpay-link-container mobile-only">
                        <p>
                            <FormattedMessage id="pages.registration.links.contactus.title" />
                        </p>
                        <TextButtonSto
                            className="button-link sto-links"
                            id="page-registration-createUser-button-contactUs"
                            labelKey="pages.registration.links.contactus.text"
                            onClick={() => updateModalVisibility(true)}
                            type="button"
                        />
                    </div>
                </div>
            </div>

            <div className="pprlpay-page-secondary-content desktop-only">
                <div className="pprlpay-link-container">
                    <p>
                        <FormattedMessage id="pages.registration.links.contactus.title" />
                    </p>
                    <TextButtonSto
                        className="button-link sto-links"
                        id="page-registration-createUser-button-contactUs"
                        labelKey="pages.registration.links.contactus.text"
                        onClick={() => updateModalVisibility(true)}
                        type="button"
                    />
                </div>
            </div>
            <ContactModal onOk={() => updateModalVisibility(false)} visible={displayModal} />
        </React.Fragment>
    );
}

SignUpContent.propTypes = {
    email: PropTypes.string.isRequired,
    onSubmit: PropTypes.func.isRequired,
    verificationkey: PropTypes.string.isRequired,
};
export default injectIntl(SignUpContent);
